module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-center wrapper-counter",
    style: (_vm.isWhite)
  }, [(_vm.title) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "d-flex"
  }, _vm._l((_vm.hours), function(hour, indexHour) {
    return _c('p', {
      key: indexHour,
      class: [
        'card',
        {
          'dark-card': _vm.darkTheme
        } ]
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(hour) + "\n\t\t\t\t")])
  })), _vm._v(" "), (_vm.showTimeWords) ? _c('span', [_vm._v("HORAS")]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: [
      'dots',
      {
        'dark-dots': _vm.darkTheme
      } ]
  }, [_vm._v(" : ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "d-flex"
  }, _vm._l((_vm.minutes), function(minute, indexMinute) {
    return _c('p', {
      key: indexMinute,
      class: [
        'card',
        {
          'dark-card': _vm.darkTheme
        } ]
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(minute) + "\n\t\t\t\t")])
  })), _vm._v(" "), (_vm.showTimeWords) ? _c('span', [_vm._v("MINUTOS")]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: [
      'dots',
      {
        'dark-dots': _vm.darkTheme
      } ]
  }, [_vm._v(" : ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "d-flex"
  }, _vm._l((_vm.seconds), function(second, indexSecond) {
    return _c('p', {
      key: indexSecond,
      class: [
        'card',
        {
          'dark-card': _vm.darkTheme
        } ]
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(second) + "\n\t\t\t\t")])
  })), _vm._v(" "), (_vm.showTimeWords) ? _c('span', [_vm._v("SEGUNDOS")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a428220","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeCounter.vue
// module id = 1078
// module chunks = 1